'use strict';

/**
 * Blog/News Page functionality
 * Handles category filtering and load more functionality
 */

const blogPage = document.querySelector('.blog-page');

if (blogPage) {
	const grid = document.getElementById('blog-posts-grid');
	const loadMoreBtn = document.getElementById('load-more-posts');
	const filtersContainer = document.querySelector('.filters-container');
	const filterBtns = document.querySelectorAll('.filters-container .btn');
	const MOBILE_BREAKPOINT = 768;
	
	/**
	 * Check if viewport is mobile size
	 */
	function isMobile() {
		return window.innerWidth <= MOBILE_BREAKPOINT;
	}
	
	let activeBtn = document.querySelector('.filters-container .btn.active');
	let currentCategory = activeBtn ? activeBtn.dataset.category : 'all';
	let currentPage = 1;
	let isLoading = false;
	
	// Create and append the sliding indicator (only visible on desktop via CSS)
	const indicator = document.createElement('span');
	indicator.className = 'filter-indicator';
	filtersContainer.prepend(indicator);
	
	/**
	 * Position the indicator on a button
	 * @param {HTMLElement} btn - The button to position on
	 * @param {number} offset - Optional horizontal offset for hover effect
	 */
	function positionIndicator(btn, offset = 0) {
		if (!btn || isMobile()) return;
		
		const containerRect = filtersContainer.getBoundingClientRect();
		const btnRect = btn.getBoundingClientRect();
		
		const left = btnRect.left - containerRect.left + offset;
		const width = btnRect.width;
		
		indicator.style.width = `${width}px`;
		indicator.style.transform = `translateX(${left}px)`;
	}
	
	// Initialize indicator position
	positionIndicator(activeBtn);
	
	// Recalculate on window resize
	window.addEventListener('resize', () => {
		positionIndicator(activeBtn);
	});
	
	/**
	 * Handle category filter click
	 */
	filterBtns.forEach(btn => {
		btn.addEventListener('click', function() {
			const category = this.dataset.category;
			
			if (category === currentCategory) return;
			
			// Update active state
			filterBtns.forEach(b => b.classList.remove('active'));
			this.classList.add('active');
			activeBtn = this;
			
			// Move indicator to new position (only on desktop)
			if (!isMobile()) {
				positionIndicator(this);
			}
			
			// Reset pagination and load posts
			currentCategory = category;
			currentPage = 1;
			
			loadPosts(true);
		});
		
		// Hover effect - slight movement towards hovered button (desktop only)
		btn.addEventListener('mouseenter', function() {
			if (isMobile() || this.classList.contains('active')) return;
			
			const activeBtnRect = activeBtn.getBoundingClientRect();
			const hoveredBtnRect = this.getBoundingClientRect();
			
			// Calculate direction and apply subtle offset
			const activeCenter = activeBtnRect.left + activeBtnRect.width / 2;
			const hoveredCenter = hoveredBtnRect.left + hoveredBtnRect.width / 2;
			const direction = hoveredCenter > activeCenter ? 1 : -1;
			const offset = direction * 8; // 8px nudge
			
			positionIndicator(activeBtn, offset);
		});
		
		btn.addEventListener('mouseleave', function() {
			if (isMobile()) return;
			// Reset to active button position
			positionIndicator(activeBtn);
		});
	});
	
	/**
	 * Handle load more click
	 */
	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', function() {
			if (isLoading) return;
			
			currentPage++;
			loadPosts(false);
		});
	}
	
	/**
	 * Show loading spinner in the grid
	 */
	function showSpinner() {
		const spinner = document.createElement('div');
		spinner.className = 'blog-page__spinner';
		spinner.innerHTML = '<span class="spinner"></span>';
		grid.appendChild(spinner);
	}
	
	/**
	 * Remove loading spinner
	 */
	function hideSpinner() {
		const spinner = grid.querySelector('.blog-page__spinner');
		if (spinner) {
			spinner.remove();
		}
	}
	
	/**
	 * Load posts via AJAX
	 * @param {boolean} replace - Whether to replace existing posts or append
	 */
	function loadPosts(replace = false) {
		if (isLoading) return;
		
		isLoading = true;
		
		if (loadMoreBtn) {
			loadMoreBtn.classList.add('loading');
			loadMoreBtn.disabled = true;
		}
		
		// Show spinner when replacing content
		if (replace) {
			// Preserve grid height to prevent scroll jump
			const currentHeight = grid.offsetHeight;
			grid.style.minHeight = `${currentHeight}px`;
			
			grid.innerHTML = '';
			showSpinner();
		}
		
		const formData = new FormData();
		formData.append('action', 'load_more_posts');
		formData.append('page', currentPage);
		formData.append('per_page', loadMoreBtn ? loadMoreBtn.dataset.perPage : 9);
		formData.append('category', currentCategory);
		
		fetch(ueccAjax.ajaxurl, {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				hideSpinner();
				
				if (replace) {
					grid.innerHTML = data.data.html;
					// Remove min-height after content is loaded
					grid.style.minHeight = '';
				} else {
					grid.insertAdjacentHTML('beforeend', data.data.html);
				}
				
				// Update load more button visibility
				if (loadMoreBtn) {
					if (data.data.has_more) {
						loadMoreBtn.style.display = '';
						loadMoreBtn.dataset.page = currentPage;
						loadMoreBtn.dataset.maxPages = data.data.max_pages;
					} else {
						loadMoreBtn.style.display = 'none';
					}
				}
			}
		})
		.catch(error => {
			console.error('Error loading posts:', error);
			hideSpinner();
			grid.style.minHeight = '';
		})
		.finally(() => {
			isLoading = false;
			
			if (loadMoreBtn) {
				loadMoreBtn.classList.remove('loading');
				loadMoreBtn.disabled = false;
			}
		});
	}
}
